import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  apiUrl: Yup.string().url(),
  apiSecret: Yup.string(),
  allowRecording: Yup.boolean(),
  validUntil: Yup.date().optional(),
});
